import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'www.posta.com.tr',
                value: 'www.posta.com.tr',
            },
            {
                label: 'secim.posta.com.tr',
                value: 'secim.posta.com.tr',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Astroloji', value: 'astroloji' },
            { label: 'Bulmaca', value: 'bulmaca' },
            { label: 'Eğitim - Kariyer', value: 'eğitim - kariyer' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Gündem', value: 'gündem' },
            { label: 'Magazin', value: 'magazin' },
            { label: 'Sağlık', value: 'sağlık' },
            { label: 'Türkiye', value: 'türkiye' },
            { label: 'Yaşam', value: 'yaşam' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'A. Yavuz Kocaömer', value: 'a. yavuz kocaömer' },
            { label: 'Ali Gürsoy', value: 'ali gürsoy' },
            { label: 'Arzu Çekirge Paksoy', value: 'arzu çekirge paksoy' },
            { label: 'Banu Şen', value: 'banu şen' },
            { label: 'Bekir Saçar', value: 'bekir saçar' },
            { label: 'Bilal Emin Turan', value: 'bilal emin turan' },
            { label: 'Bircan Tavas', value: 'bircan tavas' },
            { label: 'Burak Akkul', value: 'burak akkul' },
            { label: 'Büşra Eracun Akkaya', value: 'büşra eracun akkaya' },
            { label: 'Can Kantar', value: 'can kantar' },
            { label: 'Cem Kerpiççiler', value: 'cem kerpiççiler' },
            { label: 'Cemre BECER', value: 'cemre becer' },
            { label: 'Deniz Onuk', value: 'deniz onuk' },
            { label: 'Deniz Temur', value: 'deniz temur' },
            { label: 'Dilara Doğan', value: 'dilara doğan' },
            { label: 'Esra Çelik Şenel', value: 'esra çelik şenel' },
            { label: 'Ekrem Sarısu', value: 'ekrem sarısu' },
            { label: 'Elif Bayram', value: 'elif bayram' },
            { label: 'Elif Demirtaş Bilir', value: 'elif demirtaş bilir' },
            { label: 'Erkut Can', value: 'erkut can' },
            { label: 'Esra E. Karaosmanoğlu', value: 'esra e. karaosmanoğlu' },
            { label: 'Filiz Özkol', value: 'filiz özkol' },
            { label: 'Funda Duru', value: 'funda duru' },
            { label: 'Furkan Lüleci', value: 'furkan lüleci' },
            { label: 'Gizem Yetil', value: 'gizem yetil' },
            { label: 'Gökçen Erdoğan', value: 'gökçen erdoğan' },
            { label: 'Gözde Hatunoğlu', value: 'gözde hatunoğlu' },
            { label: 'Güney Öztürk', value: 'güney öztürk' },
            { label: 'Hakan Çelik', value: 'hakan çelik' },
            { label: 'Hande Kazanova', value: 'hande kazanova' },
            { label: 'Haydar Dümen', value: 'haydar dümen' },
            { label: 'Işıl Cinmen', value: 'işıl cinmen' },
            { label: 'Işınsu Kestelli', value: 'işınsu kestelli' },
            { label: 'Kerem Akça', value: 'kerem akça' },
            { label: 'Mehmet Coşkundeniz', value: 'mehmet coşkundeniz' },
            { label: 'Mehmet Nuri Turan', value: 'mehmet nuri turan' },
            { label: 'Mehmet Yalçınkaya', value: 'mehmet yalçınkaya' },
            { label: 'Melis Apaydın İde', value: 'melis apaydın i̇de' },
            { label: 'Mine Bozkurt', value: 'mine bozkurt' },
            { label: 'Murat Çelik', value: 'murat çelik' },
            { label: 'Murat Gülderen', value: 'murat gülderen' },
            { label: 'Mustafa Bakacak', value: 'mustafa bakacak' },
            { label: 'Öner Döşer', value: 'öner döşer' },
            { label: 'Oral Çalışlar', value: 'oral çalışlar' },
            { label: 'Özgür Gökmen Çelenk', value: 'özgür gökmen çelenk' },
            { label: 'Özlem Denizmen', value: 'özlem denizmen' },
            { label: 'Rauf Tamer', value: 'rauf tamer' },
            { label: 'Rıza Sönmez', value: 'rıza sönmez' },
            { label: 'Rükzan Sağır', value: 'rükzan sağır' },
            { label: 'Sabanur Kıraç', value: 'sabanur kıraç' },
            { label: 'Sadık Gültekin', value: 'sadık gültekin' },
            { label: 'Serap Torun', value: 'serap torun' },
            { label: 'Serdar Bora Bayraktaroğlu', value: 'serdar bora bayraktaroğlu' },
            { label: 'Serpil Dokurel', value: 'serpil dokurel' },
            { label: 'Şirin Sever', value: 'şirin sever' },
            { label: 'Şule Özdemir', value: 'şule özdemir' },
            { label: 'Suna Akyıldız', value: 'suna akyıldız' },
            { label: 'Tamer Heper', value: 'tamer heper' },
            { label: 'Turcel Orman', value: 'turcel orman' },
            { label: 'Ufuk Tarhan', value: 'ufuk tarhan' },
            { label: 'Uğur Alkapar', value: 'uğur alkapar' },
            { label: 'Verda Özer', value: 'verda özer' },
            { label: 'Yasemin Candemir', value: 'yasemin candemir' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Abdullah Karlıdağ', value: 'abdullah.karlidag' },
            { label: 'Adem Özdoğan', value: 'ademozdogan' },
            { label: 'Aydan Durak', value: 'aydan.durak' },
            { label: 'Bahar Saygılıer', value: 'bsaygilier' },
            { label: 'Büşra Akkaya', value: 'bakkaya' },
            { label: 'Büşra Özbelli', value: 'bozbelli' },
            { label: 'Cemil Eren Mutluay', value: 'emutluay' },
            { label: 'Elif Bayram', value: 'elif.bayram' },
            { label: 'Elif Demirtaş', value: 'edemirtas' },
            { label: 'Emir Ceran', value: 'emir.ceran' },
            { label: 'Faruk Melik Çevik', value: 'fcevik' },
            { label: 'Ferhat Çilli', value: 'fcilli' },
            { label: 'Gizem Yetil', value: 'gyetil' },
            { label: 'İpek Alemdar', value: 'ipek.alemdar' },
            { label: 'Lara Bayrak', value: 'lara.bayrak' },
            { label: 'Mehmet Nuri Turan', value: 'mturan' },
            { label: 'Mine Bozkurt', value: 'mine.bozkurt' },
            { label: 'Onur Binay', value: 'onurbinay' },
            { label: 'Selen Serdaroğlu', value: 'selen.serdaroglu' },
            { label: 'Serpil Dokurel', value: 'serpil.dokurel' },
            { label: 'Şenay Yurtalan', value: 'senay.yurtalan' },
            { label: 'Tuncel Orman', value: 'turcel.orman' },
            { label: 'Ömercan Altay', value: 'omercanaltay' },
            { label: 'Ömer Ekinci', value: 'omer.ekinci' },
            { label: 'Volkan Şahin', value: 'vsahin' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]
export const coreApiPageFilterPostaObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
